const TextFromStates = {
  1: 'TEATRO',
  2: 'IMPULSO',
  3: 'MATERIALIZAR',
  4: 'INCONSCIENTE',
};

export default TextFromStates;
